// Экраны шагов заказа — отдельные файлы сборки (изменение seo): публичным страницам их код не
// нужен. Как только покупатель открыл заказ, код всех шагов подгружается заранее, чтобы
// переход «эскиз → покупка → оформление» был мгновенным, как до разбиения сборки.
export const ORDER_SCREEN_LOADERS = {
  layout: () => import("../orders/OrderLayout"),
  photos: () => import("../screens/photos/PhotoStep"),
  look: () => import("../screens/look/LookRoute"),
  lookOwn: () => import("../screens/look/OwnCharacterScreen"),
  concept: () => import("../screens/concept/ConceptRoute"),
  purchase: () => import("../screens/purchase/PurchaseScreen"),
  checkout: () => import("../screens/purchase/CheckoutScreen"),
  payment: () => import("../screens/purchase/PaymentScreen"),
  model: () => import("../screens/model/ModelScreen"),
  status: () => import("../screens/status/StatusScreen"),
};

export function prefetchOrderScreens(): void {
  // В модульных тестах — нет: загрузчик vitest путается в одновременных импортах экранов, которые
  // ссылаются друг на друга, а ускорять там нечего. Браузер такие импорты разбирает сам.
  if (import.meta.env.MODE === "test") return;
  for (const load of Object.values(ORDER_SCREEN_LOADERS)) {
    // Не загрузилось (нет связи) — не страшно: экран загрузится при переходе.
    load().catch(() => undefined);
  }
}
